import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Backdrop } from '../../components/Themed.js';
import { setLocation, setPrinterMac, getDurations } from '../../data/app/AppActions.js';
import { getEmployees } from '../../data/employee/EmployeeActions';

import { t } from '../../locales';
import '../../components/input/Input.css';
import './Locations.css';

class Locations extends React.Component {
  constructor(props) {
    super(props);

    this.locationClick = this.locationClick.bind(this);

    this.state = {
      printerMac: '',
    };
  }

  locationClick(location) {
    this.props.setLocation(location);
    this.props.getEmployees(location.id);
    this.props.getDurations(location);
    this.props.history.push('/');
  }

  setPrinterMac(event) {
    this.setState({ printerMac: event.target.value });
    this.props.setPrinterMac(event.target.value);
  }

  renderPrinterInput() {
    if (!this.props.serviceNumbersEnabled) return null;
    return (
      <div>
        <div className="title">
          {t('locations_page.please_enter_printer_MAC')}
        </div>
        <div style={{ width: '40%', marginLeft: '30%' }}>
          <input
            className="control-input"
            autoComplete="off"
            placeholder="00:11:62:0d:53:8f"
            value={this.state.printerMac}
            onChange={event => this.setPrinterMac(event)}
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        <Backdrop id="backdrop" />
        <div className="scroll-container content-container">
          <div className="page-container">
            {this.renderPrinterInput()}

            <div className="title">
              {t('locations_page.please_select_kiosk_location')}
            </div>
            <div className="content-medium">
              {this.props.locations.map(location => (
                <Button
                  key={location.id}
                  onClick={() => this.locationClick(location)}
                >
                  {location.full_address}
                </Button>
              ))}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    locations: state.app.locations,
    serviceNumbersEnabled: state.app.businessInfo
      ? state.app.businessInfo.company.service_numbers_enabled
      : false,
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    { setLocation, getEmployees, getDurations, setPrinterMac }
  )(Locations)
);
